<div *ngIf="showLastUpdated && lastUpdatedLabel" class="Spa_Style_Note" [innerHTML]="lastUpdatedLabel | safe : 'html'"></div>

<div *ngIf="showMainCMS" class="Spa_Style_Note" [innerHTML]="CMS || defaultCMS | safe : 'html'"></div>

<div *ngIf="formCMS" class="Spa_Style_Note" [innerHTML]="formCMS | safe : 'html'"></div>
